// @arch:pure-engine
// One initial directive contract for legacy and unified composers.
const MODE_PREFIX = {
  plan: (t) =>
    `Antes de executar, DELIBERE o plano comigo pensando alto: entenda o objetivo, considere 2+ abordagens e DEBATA os trade-offs, exponha premissas e riscos, e PERGUNTE o que for genuinamente ambíguo (não chute). Só depois de raciocinar consolide um PLANO detalhado (passos, arquivos afetados, riscos) para minha aprovação. Não comece a implementar ainda.\n\nTarefa: ${t}`,
  research: (t) =>
    `Faça uma DEEP RESEARCH sobre o tema abaixo: busque em múltiplas fontes, verifique as afirmações de forma adversarial e sintetize com citações.\n\nTema: ${t}`,
  // Recuperados do Aba-Apolo (transforms REAIS do turn, não fake): Debug foca
  // causa-raiz antes de corrigir; Ask é read-only (não altera nada).
  debug: (t) =>
    `Investigue a CAUSA-RAIZ primeiro: reproduza, forme hipóteses e prove qual é a verdadeira ANTES de propor correção. Não altere nada até confirmar o diagnóstico.\n\nProblema: ${t}`,
  // F13-E7-T02 — 'ask' saiu daqui: a bolha fica com o texto CRU do usuário; o
  // read-only vem do gate (chatModes) + ASK_MODE_DIRECTIVE como system.
};
export function initialCollaborationText(mode, text) { return MODE_PREFIX[mode] ? MODE_PREFIX[mode](text) : text; }

// A label change never revokes an accepted read-only capability.
export function isCollaborationReadOnly(mode, flags) {
  return flags?.read_only === true || ['ask', 'research'].includes(mode);
}
